import styled, { css, FlattenSimpleInterpolation } from 'styled-components';
import { Variant } from './heading';

export const h1 = css`
  font-size: 2.5rem;
  line-height: 3.5rem;
  font-weight: bold;
`;

export const h2 = css`
  font-size: 2rem;
  line-height: 3rem;
  font-weight: bold;
`;

export const h3 = css`
  font-size: 1.5rem;
  line-height: 2rem;
  font-weight: bold;
`;

export const h4 = css`
  font-size: 1.25rem;
  line-height: 2rem;
  font-weight: bold;
`;

export const h5 = css`
  font-size: 1rem;
  line-height: 1.5rem;
  font-weight: bold;
`;

export const h6 = css`
  font-size: 1rem;
  line-height: 1.5rem;
  font-weight: 600;
`;

export const StyledHeading = styled.div<{ variant: Variant; faded: boolean }>`
  margin: 0;
  padding: 0;

  ${({ variant }): FlattenSimpleInterpolation | undefined => {
    if (variant === 'h1') {
      return h1;
    }

    if (variant === 'h2') {
      return h2;
    }

    if (variant === 'h3') {
      return h3;
    }

    if (variant === 'h4') {
      return h4;
    }

    if (variant === 'h5') {
      return h5;
    }

    if (variant === 'h6') {
      return h6;
    }

    return;
  }}

  color: ${({ theme, faded }): string =>
    faded === true ? theme.palette_gray_60 : 'inherit'};
`;
